"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpExportCSV = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_csv_downloader_1 = __importDefault(require("react-csv-downloader"));
var DpExportCSV = function (_a) {
    var columns = _a.columns, data = _a.data, filename = _a.filename, children = _a.children, _b = _a.wrapColumnChar, wrapColumnChar = _b === void 0 ? '"' : _b;
    var filenameExt = filename || 'file.csv';
    return ((0, jsx_runtime_1.jsx)(react_csv_downloader_1.default, { datas: data, columns: columns, filename: filenameExt, prefix: false, suffix: false, wrapColumnChar: wrapColumnChar, children: children }));
};
exports.DpExportCSV = DpExportCSV;
exports.default = exports.DpExportCSV;
